import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.1665 12.5H3.33317C2.89114 12.5 2.46722 12.3244 2.15466 12.0118C1.8421 11.6992 1.6665 11.2753 1.6665 10.8333V3.33329C1.6665 2.89127 1.8421 2.46734 2.15466 2.15478C2.46722 1.84222 2.89114 1.66663 3.33317 1.66663H10.8332C11.2752 1.66663 11.6991 1.84222 12.0117 2.15478C12.3242 2.46734 12.4998 2.89127 12.4998 3.33329V4.16663M9.1665 7.49996H16.6665C17.587 7.49996 18.3332 8.24615 18.3332 9.16663V16.6666C18.3332 17.5871 17.587 18.3333 16.6665 18.3333H9.1665C8.24603 18.3333 7.49984 17.5871 7.49984 16.6666V9.16663C7.49984 8.24615 8.24603 7.49996 9.1665 7.49996Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCopy;
